"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attributeEmptyRule = void 0;
exports.getEmptyAttributes = getEmptyAttributes;
exports.isAttributeEmpty = isAttributeEmpty;
const utils_1 = require("@azimutt/utils");
const database_1 = require("../../database");
const databaseUtils_1 = require("../../databaseUtils");
const rule_1 = require("../rule");
const ruleId = 'attribute-empty';
const ruleName = 'empty attribute';
const ruleDescription = 'nullable attributes with cardinality=0 or 100% nulls when entity has some rows';
const CustomRuleConf = rule_1.RuleConf.extend({
    ignores: database_1.AttributeId.array().optional()
}).strict().describe('AttributeEmptyConf');
exports.attributeEmptyRule = {
    id: ruleId,
    name: ruleName,
    description: ruleDescription,
    conf: { level: rule_1.RuleLevel.enum.low },
    zConf: CustomRuleConf,
    analyze(conf, now, db, queries, history, reference) {
        const refIgnores = reference.map(r => r.entity && r.attribute ? { ...r.entity, attribute: r.attribute } : undefined).filter(utils_1.isNotUndefined);
        const ignores = refIgnores.concat(conf.ignores?.map(databaseUtils_1.attributeRefFromId) || []);
        return (db.entities || [])
            .flatMap(getEmptyAttributes)
            .filter(r => !ignores.some(i => (0, databaseUtils_1.attributeRefSame)(i, r)))
            .map(r => ({
            ruleId,
            ruleName,
            ruleLevel: conf.level,
            message: `Attribute ${(0, databaseUtils_1.attributeRefToId)(r)} is empty.`,
            entity: (0, databaseUtils_1.attributeRefToEntity)(r),
            attribute: r.attribute,
        }));
    }
};
function getEmptyAttributes(entity) {
    if (entity.stats?.rows || 0 > 0) {
        return (entity.attrs || []).filter(isAttributeEmpty).map(attribute => ({ ...(0, databaseUtils_1.entityToRef)(entity), attribute: [attribute.name] }));
    }
    else {
        return [];
    }
}
function isAttributeEmpty(a) {
    return a.null === true && ((a.stats?.cardinality !== undefined ? a.stats.cardinality === 0 : false) || (a.stats?.nulls !== undefined ? a.stats.nulls === 1 : false));
}
//# sourceMappingURL=attributeEmpty.js.map